import { useState, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { contentTypes } from '../../data';
import Button from '../../components/Button/Button';
import Upload from '../../assets/icons/Upload';

import Video from '../../assets/icons/Video';

import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';
import { handleContentUpload } from '../../services/handleImage';
import { createUnitLesson } from '../../services/learnService';
import Audio from '../../assets/icons/Audio';
import BigAudio from '../../assets/icons/BigAudio';
import Image from '../../assets/icons/Image';
import Docs from '../../assets/icons/Docs';
import BigDoc from '../../assets/icons/BigDoc';
import Notif from '../../assets/icons/Notif';

import Quiz from './Quiz';

import { toast } from 'react-hot-toast';

const ContentUpload = ({ sn }) => {
  const [contentType, setContentType] = useState([]);
  const [progress, setProgress] = useState(0);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [textActivity, setTextActivity] = useState(false);
  const [imageActivity, setImageActivity] = useState(false);
  const [audioActivity, setAudioActivity] = useState(false);
  const [quizActivity, setQuizActivity] = useState(true);
  const [docActivity, setDocActivity] = useState(false);
  const [videoActivity, setVideoActivity] = useState(false);
  const [videoUrl, setVideoUrl] = useState([]);
  const [audioUrl, setAudioUrl] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [docUrl, setDocUrl] = useState([]);
  const [file, setFile] = useState('');
  const [title, setTitle] = useState('');
  const [videoTitle, setVideoTitle] = useState('');
  const [audioTitle, setAudioTitle] = useState('');
  const [imageTitle, setImageTitle] = useState('');
  const [textTitle, setTextTitle] = useState('');
  const [docTitle, setDocTitle] = useState('');
  const [quizTitle, setQuizTitle] = useState('');
  const [contentSelection, setContentSelection] = useState(true);
  const [count, setCount] = useState(0);
  const [addLoading, setAddLoading] = useState(false);

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };

  const handleCheck = (e) => {
    if (e.target.name === 'text') {
      setTextActivity(e.target.checked);
      return;
    }

    if (e.target.name === 'doc') {
      setDocActivity(e.target.checked);
      return;
    }

    if (e.target.name === 'audio') {
      setAudioActivity(e.target.checked);
      return;
    }

    if (e.target.name === 'video') {
      setVideoActivity(e.target.checked);
      return;
    }

    if (e.target.name === 'image') {
      setImageActivity(e.target.checked);
      return;
    }

    if (e.target.name === 'quiz') {
      setQuizActivity(e.target.checked);
      return;
    }
  };

  const handleTitleChange = (evt) => {
    setTitle(evt.target.value);
  };

  const handleVideoTitle = (evt) => {
    setVideoTitle(evt.target.value);
  };

  const handleAudioTitle = (evt) => {
    setAudioTitle(evt.target.value);
  };

  const handleDocTitle = (evt) => {
    setDocTitle(evt.target.value);
  };

  const handleImageTitle = (evt) => {
    setImageTitle(evt.target.value);
  };

  const handleTextTitle = (evt) => {
    setTextTitle(evt.target.value);
  };

  const handleQuizTitle = (evt) => {
    setQuizTitle(evt.target.value);
  };

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '100%',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  //upload video on drop
  const { getRootProps: getRootVideoProps, getInputProps: getInputVideoProps } =
    useDropzone({
      onDrop: async (acceptedFiles) => {
        // do your thing
        let itemId = localStorage.getItem('itemId');
        let { school } = JSON.parse(localStorage.getItem('userData'));
        let course = JSON.parse(localStorage.getItem('course'));
        let topic = JSON.parse(localStorage.getItem('topic'));
        let id = JSON.parse(localStorage.getItem(`lesson${sn}`));

        //saved titles
        let sVideoTitle = localStorage.getItem('videoTitle');
        if (!sVideoTitle) {
          toast.error('Video title is required');
          return;
        }

        if (!id) {
          toast.error('Please save lesson title to proceed');
          return;
        }
        setFile(acceptedFiles[0]);

        setVideoUrl([
          ...videoUrl,
          {
            id: Number(itemId),
            name: acceptedFiles[0].name,
            preview: URL.createObjectURL(acceptedFiles[0]),
          },
        ]);

        try {
          setUploading(true);

          let res = await handleContentUpload(
            sn + 1,
            sVideoTitle,
            90,
            'video',
            videoActivity,
            acceptedFiles[0],
            '',
            school.id,
            course.id,
            topic.id,
            id,
            '',
            (event) => {
              setProgress(Math.round((100 * event.loaded) / event.total));
            }
          );
          setUploading(false);
          toast.success(res.message);
          localStorage.removeItem('videoTitle');
        } catch (error) {
          console.log(error);
          setVideoUrl(videoUrl.filter((el) => el.id !== itemId));
          setUploading(false);
          toast.error(error?.response?.data?.data?.errors?.file[0]);
        }
      },
    });

  const {
    getRootProps: getImageRootProps,
    getInputProps: getImageInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: 'image/*',
    onDrop: async (acceptedFiles) => {
      let itemId = localStorage.getItem('itemId');
      let { school } = JSON.parse(localStorage.getItem('userData'));
      let course = JSON.parse(localStorage.getItem('course'));
      let topic = JSON.parse(localStorage.getItem('topic'));
      let id = JSON.parse(localStorage.getItem(`lesson${sn}`));

      //saved titles
      let sImageTitle = localStorage.getItem('imageTitle');
      if (!sImageTitle) {
        toast.error('Image title is required');
        return;
      }

      if (!id) {
        toast.error('Please save lesson title to proceed');
        return;
      }
      setFile(acceptedFiles[0]);

      setImageUrl([
        ...imageUrl,
        {
          id: Number(itemId),
          name: acceptedFiles[0].name,
          preview: URL.createObjectURL(acceptedFiles[0]),
        },
      ]);

      try {
        setUploading(true);

        let res = await handleContentUpload(
          sn + 1,
          sImageTitle,
          90,
          'image',
          imageActivity,
          acceptedFiles[0],
          'text-left',
          school.id,
          course.id,
          topic.id,
          id,
          '',
          (event) => {
            setProgress(Math.round((100 * event.loaded) / event.total));
          }
        );
        setUploading(false);
        toast.success(res.message);
        localStorage.removeItem('imageTitle');
      } catch (error) {
        console.log(error);
        setImageUrl(imageUrl.filter((el) => el.id !== itemId));
        setUploading(false);
        toast.error(error?.response?.data?.data?.errors?.file[0]);
      }
    },
  });

  //document drop
  const { getRootProps: getDocRootProps, getInputProps: getDocInputProps } =
    useDropzone({
      accept: 'application/pdf',
      onDrop: async (acceptedFiles) => {
        let { school } = JSON.parse(localStorage.getItem('userData'));
        let course = JSON.parse(localStorage.getItem('course'));
        let topic = JSON.parse(localStorage.getItem('topic'));
        let id = JSON.parse(localStorage.getItem(`lesson${sn}`));
        let itemId = localStorage.getItem('itemId');
        //saved titles
        let sDocTitle = localStorage.getItem('docTitle');

        if (!sDocTitle) {
          toast.error('Document title is required');
          return;
        }

        if (!id) {
          toast.error('Please save lesson title to proceed');
          return;
        }

        setFile(acceptedFiles[0]);

        setDocUrl([
          ...docUrl,
          {
            id: Number(itemId),
            name: acceptedFiles[0].name,
            preview: URL.createObjectURL(acceptedFiles[0]),
          },
        ]);
        try {
          setUploading(true);

          let res = await handleContentUpload(
            sn + 1,
            sDocTitle,
            90,
            'doc',
            docActivity,
            acceptedFiles[0],
            '',
            school.id,
            course.id,
            topic.id,
            id,
            '',
            (event) => {
              setProgress(Math.round((100 * event.loaded) / event.total));
            }
          );
          setUploading(false);
          toast.success(res.message);
          localStorage.removeItem('docTitle');
        } catch (error) {
          setUploading(false);
          setDocUrl(docUrl.filter((el) => el.id !== itemId));
          toast.error(error?.response?.data?.data?.errors?.file[0]);
        }
      },
    });

  //audio drop

  const { getRootProps: getAudioRootProps, getInputProps: getAudioInputProps } =
    useDropzone({
      onDrop: async (acceptedFiles) => {
        let itemId = localStorage.getItem('itemId');
        let { school } = JSON.parse(localStorage.getItem('userData'));
        let course = JSON.parse(localStorage.getItem('course'));
        let topic = JSON.parse(localStorage.getItem('topic'));
        let id = JSON.parse(localStorage.getItem(`lesson${sn}`));

        //saved titles

        let sAudioTitle = localStorage.getItem('audioTitle');

        if (!sAudioTitle) {
          toast.error('Audio title is required');
          return;
        }

        if (!id) {
          toast.error('Please save lesson title to proceed');
          return;
        }
        setFile(acceptedFiles[0]);

        setAudioUrl([
          ...audioUrl,
          {
            id: Number(itemId),
            name: acceptedFiles[0].name,
            preview: URL.createObjectURL(acceptedFiles[0]),
          },
        ]);
        try {
          setUploading(true);
          let res = await handleContentUpload(
            sn,
            sAudioTitle,
            90,
            'audio',
            audioActivity,
            acceptedFiles[0],
            '',
            school.id,
            course.id,
            topic.id,
            id,
            '',
            (event) => {
              setProgress(Math.round((100 * event.loaded) / event.total));
            }
          );

          setUploading(false);
          toast.success(res.message);
          localStorage.removeItem('audioTitle');
        } catch (error) {
          setUploading(false);
          setAudioUrl(audioUrl.filter((el) => el.id !== itemId));
          toast.error(error?.response?.data?.data?.errors?.file[0]);
        }
      },
    });

  const createSingleLesson = async (lessonIndex) => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    let course = JSON.parse(localStorage.getItem('course'));
    let topic = JSON.parse(localStorage.getItem('topic'));
    let sTitle = localStorage.getItem('title');
    setLoading(true);

    let data = {
      sn: lessonIndex + 1,
      title: sTitle,
    };
    try {
      let lessonRes = await createUnitLesson(
        school.id,
        course.id,
        topic.id,
        data
      );
      let { id, sn } = lessonRes.data.lesson;
      localStorage.setItem(`lesson${lessonIndex}`, id);
      toast.success('Lesson saved successfully');
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const saveText = async () => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    let course = JSON.parse(localStorage.getItem('course'));
    let topic = JSON.parse(localStorage.getItem('topic'));
    let id = JSON.parse(localStorage.getItem(`lesson${sn}`));

    //saved titles
    let sTitle = localStorage.getItem('title');
    let sTextTitle = localStorage.getItem('textTitle');

    if (!sTextTitle) {
      toast.error('Text title is required');
      return;
    }

    if (!id) {
      toast.error('Please save lesson title to proceed');
      return;
    }

    if (editorState.getCurrentContent().getPlainText() === '') {
      toast.error('Text cannot be empty');
      return;
    }
    try {
      setLoading(true);

      let res = await handleContentUpload(
        sn,
        sTextTitle,
        90,
        'text',
        textActivity,
        '',
        '',
        school.id,
        course.id,
        topic.id,
        id,
        editorState.getCurrentContent().getPlainText(),
        (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        }
      );
      setLoading(false);
      // setContentType(contentType.filter((el, idx) => idx !== lessonIndex));
      toast.success(res.message);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.data?.errors?.file[0]);
      setLoading(false);
    }
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const activityTag = () => {
    return (
      <>
        <div className='activity-tag'>
          <svg
            width='14'
            height='12'
            viewBox='0 0 14 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M13.6673 5.33333V0H9.00065V2H5.00065V0H0.333984V5.33333H5.00065V3.33333H6.33398V10H9.00065V12H13.6673V6.66667H9.00065V8.66667H7.66732V3.33333H9.00065V5.33333H13.6673ZM3.66732 4H1.66732V1.33333H3.66732V4ZM10.334 8H12.334V10.6667H10.334V8ZM10.334 1.33333H12.334V4H10.334V1.33333Z'
              fill='#4CC5EC'
            />
          </svg>

          <p>Activity</p>
        </div>
      </>
    );
  };

  const addMoreContent = (content) => {
    setAddLoading(true);
    setTimeout(() => {
      setCount(count + 1);
      setContentType([...contentType, content]);
    }, 100);
    setAddLoading(false);
  };

  return (
    <div className='content'>
      <div className='content__dot'></div>
      <div className='add-course__topic-content' style={{ width: '100%' }}>
        <div
          className='auth-wrapper__right__form__inputwrapper eye-position'
          style={{ width: '100%' }}
        >
          <label htmlFor='subject'>
            Lesson {sn + 1}.0 : Create lesson title
          </label>

          <input
            type='text'
            onChange={handleTitleChange}
            placeholder='Enter a title for this lesson'
            onBlur={() => {
              localStorage.setItem('title', title);
            }}
          />
          <div
            style={{
              display: 'flex',
              marginBottom: '30px',
              flexDirection: 'column',
              marginLeft: 'auto',
              gap: '16px',
            }}
          >
            <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
              max of 80 characters
            </p>
            <Button
              text={loading ? 'Saving...' : `Save Lesson Title`}
              className='orange-border'
              onClick={() => createSingleLesson(sn)}
              disabled={!title}
            />
          </div>

          <div className='eye-icon'></div>
        </div>

        {Array(contentType.length)
          .fill(contentType.length)
          .map((el, id) => (
            <div>
              {contentType[id] === 'Text' && (
                <div className='add-course__content-wrap'>
                  <label
                    className='add-course__content-selection__head'
                    style={{ marginBottom: '16px' }}
                  >
                    <div
                      className='add-course__content-selection__head__title'
                      style={{ display: 'flex', gap: '16px' }}
                    >
                      {' '}
                      <p>
                        {' '}
                        Text {sn + 1}.0.{id + 1} <span>Create text title</span>
                      </p>
                      {textActivity && activityTag()}
                    </div>

                    <p
                      className='add-course__content-selection__head__action'
                      onClick={() =>
                        setContentType(
                          contentType.filter((el, idx) => idx !== id)
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      Cancel
                    </p>
                  </label>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      onChange={handleTextTitle}
                      placeholder='Enter a title for this text'
                      onBlur={() => {
                        localStorage.setItem('textTitle', textTitle);
                      }}
                    />
                    <div className='eye-icon'></div>
                    <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                      max of 80 characters
                    </p>
                  </div>
                  <div className='add-course__text-editor'>
                    <Editor
                      editorState={editorState}
                      wrapperClassName='demo-wrapper'
                      editorClassName='demo-editor'
                      onEditorStateChange={onEditorStateChange}
                    />
                  </div>
                  <div
                    className='add-course__text-editor__cancel'
                    style={{ marginTop: '20px' }}
                  >
                    <div className='activity-check'>
                      <input
                        type='checkbox'
                        name='text'
                        onChange={handleCheck}
                      />
                      <p>Check the box if this is an activity for students</p>
                    </div>
                    <Button
                      text={loading ? 'Saving...' : `Save Text`}
                      className='orange-border'
                      onClick={() => saveText(sn + 1, id)}
                    />
                  </div>
                </div>
              )}

              {contentType[id] === 'Image' && (
                <div className='add-course__content-wrap'>
                  <label
                    className='add-course__content-selection__head'
                    style={{ marginBottom: '16px' }}
                  >
                    <div
                      className='add-course__content-selection__head__title'
                      style={{ display: 'flex', gap: '16px' }}
                    >
                      {' '}
                      <p>
                        Image {sn + 1}.0.{id + 1}: Create Image Title
                      </p>
                      {imageActivity && activityTag()}
                    </div>

                    <p
                      onClick={() =>
                        setContentType(
                          contentType.filter((el, idx) => idx !== id)
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      Cancel
                    </p>
                  </label>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      onChange={handleImageTitle}
                      placeholder='Enter a title for this image'
                      onBlur={() => {
                        localStorage.setItem('imageTitle', imageTitle);
                      }}
                    />
                    <div className='eye-icon'></div>
                    <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                      max of 80 characters
                    </p>
                  </div>

                  <div className='dropzone-video'>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <label htmlFor='progress-bar'>{progress}%</label>
                        <progress
                          id='progress-bar'
                          value={progress}
                          max='100'
                        ></progress>
                      </div>
                    ) : imageUrl.filter((el) => el.id === id).length > 0 ? (
                      <>
                        <div className='video-preview'>
                          <div className='video-preview__audio'>
                            <img
                              src={
                                imageUrl.filter((el) => el.id === id)[0]
                                  ?.preview
                              }
                              alt=''
                            />
                          </div>
                          <div className='video-preview__video-details'>
                            <div className='video-preview__video-details__icon'>
                              <Image />
                            </div>
                            <p>
                              {imageUrl.filter((el) => el.id === id)[0]?.name}
                            </p>
                          </div>
                        </div>
                        <div
                          className='replace-vid'
                          onClick={() =>
                            setImageUrl(imageUrl.filter((el) => el.id !== id))
                          }
                        >
                          <Upload />
                          <p>Replace Image</p>
                        </div>
                      </>
                    ) : (
                      <div className='container'>
                        <div
                          {...getImageRootProps({
                            style,
                            onDrop: (event) =>
                              localStorage.setItem('itemId', id),
                            onClick: () => localStorage.setItem('itemId', id),
                          })}
                        >
                          <input {...getImageInputProps({})} />

                          <Upload />
                          <p>Drag and drop image or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='add-course__text-editor__cancel'>
                    <div className='activity-check'>
                      <input
                        type='checkbox'
                        onChange={handleCheck}
                        name='image'
                      />
                      <p>Check the box if this is an activity for students</p>
                    </div>
                  </div>
                </div>
              )}

              {contentType[id] === 'Video' && (
                <div className='add-course__content-wrap'>
                  <label
                    className='add-course__content-selection__head'
                    style={{ marginBottom: '16px' }}
                  >
                    <div
                      className='add-course__content-selection__head__title'
                      style={{ display: 'flex', gap: '16px' }}
                    >
                      {' '}
                      <p>
                        Video {sn + 1}.0.{id + 1}: Create Video Title
                      </p>
                      {videoActivity && activityTag()}
                    </div>

                    <p
                      className='add-course__content-selection__head__action'
                      onClick={() =>
                        setContentType(
                          contentType.filter((el, idx) => idx !== id)
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      Cancel
                    </p>
                  </label>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      onChange={handleVideoTitle}
                      placeholder='Enter a title for this video'
                      onBlur={() => {
                        localStorage.setItem('videoTitle', videoTitle);
                      }}
                    />
                    <div className='eye-icon'></div>
                    <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                      max of 80 characters
                    </p>
                  </div>

                  <div className='dropzone-video'>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <label htmlFor='progress-bar'>{progress}%</label>
                        <progress
                          id='progress-bar'
                          value={progress}
                          max='100'
                        ></progress>
                      </div>
                    ) : videoUrl.filter((el) => el.id === id).length > 0 ? (
                      <>
                        <div className='video-preview'>
                          <video
                            src={
                              videoUrl.filter((el) => el.id === id)[0]?.preview
                            }
                          ></video>
                          <div className='video-preview__video-details'>
                            <div className='video-preview__video-details__icon'>
                              <Video />
                            </div>
                            <p>
                              {videoUrl.filter((el) => el.id === id)[0]?.name}
                            </p>
                          </div>
                        </div>
                        <div
                          className='replace-vid'
                          onClick={() =>
                            setVideoUrl(videoUrl.filter((el) => el.id !== id))
                          }
                        >
                          <Upload />
                          <p>Replace Video</p>
                        </div>
                      </>
                    ) : (
                      <div className='container'>
                        <div
                          {...getRootVideoProps({
                            style,
                            onDrop: (event) => () =>
                              localStorage.setItem('itemId', id),
                            onClick: () => localStorage.setItem('itemId', id),
                          })}
                        >
                          <input {...getInputVideoProps()} />
                          <Upload />
                          <p>Drag and drop video or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='add-course__text-editor__cancel'>
                    <div className='activity-check'>
                      <input
                        type='checkbox'
                        onChange={handleCheck}
                        name='video'
                      />
                      <p>Check the box if this is an activity for students</p>
                    </div>
                  </div>
                </div>
              )}

              {contentType[id] === 'Audio' && (
                <div className='add-course__content-wrap'>
                  <label
                    className='add-course__content-selection__head'
                    style={{ marginBottom: '16px' }}
                  >
                    <div
                      className='add-course__content-selection__head__title'
                      style={{ display: 'flex', gap: '16px' }}
                    >
                      {' '}
                      <p>
                        Audio {sn + 1}.0.{id + 1}: Create Audio Title
                      </p>
                      {audioActivity && activityTag()}
                    </div>

                    <p
                      className='add-course__content-selection__head__action'
                      onClick={() =>
                        setContentType(
                          contentType.filter((el, idx) => idx !== id)
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      Cancel
                    </p>
                  </label>
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      onChange={handleAudioTitle}
                      placeholder='Enter a title for this audio'
                      onBlur={() => {
                        localStorage.setItem('audioTitle', audioTitle);
                      }}
                    />
                    <div className='eye-icon'></div>
                    <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                      max of 80 characters
                    </p>
                  </div>

                  <div className='dropzone-video'>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <label htmlFor='progress-bar'>{progress}%</label>
                        <progress
                          id='progress-bar'
                          value={progress}
                          max='100'
                        ></progress>
                      </div>
                    ) : audioUrl.filter((el) => el.id === id).length > 0 ? (
                      <>
                        <div className='video-preview'>
                          <div className='video-preview__audio'>
                            <BigAudio />
                          </div>
                          <div className='video-preview__video-details'>
                            <div className='video-preview__video-details__icon'>
                              <Audio />
                            </div>
                            <p>
                              {audioUrl.filter((el) => el.id === id)[0]?.name}
                            </p>
                          </div>
                        </div>
                        <div
                          className='replace-vid'
                          onClick={() =>
                            setAudioUrl(audioUrl.filter((el) => el.id !== id))
                          }
                        >
                          <Upload />
                          <p>Replace Audio</p>
                        </div>
                      </>
                    ) : (
                      <div className='container'>
                        <div
                          {...getAudioRootProps({
                            style,
                            onDrop: (event) => () =>
                              localStorage.setItem('itemId', id),
                            onClick: () => localStorage.setItem('itemId', id),
                          })}
                        >
                          <input {...getAudioInputProps()} />
                          <Upload />
                          <p>Drag and drop audio or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='add-course__text-editor__cancel'>
                    <div className='activity-check'>
                      <input
                        type='checkbox'
                        onChange={handleCheck}
                        name='audio'
                      />
                      <p>Check the box if this is an activity for students</p>
                    </div>
                  </div>
                </div>
              )}

              {contentType[id] === 'Quiz' && (
                <div className='add-course__content-wrap'>
                  <label
                    className='add-course__content-selection__head'
                    style={{ marginBottom: '16px' }}
                  >
                    <div
                      className='add-course__content-selection__head__title'
                      style={{ display: 'flex', gap: '16px' }}
                    >
                      {' '}
                      <p>
                        Quiz {sn + 1}.0.{id + 1}: Create Quiz Title
                      </p>
                      {quizActivity && activityTag()}
                    </div>

                    <p
                      className='add-course__content-selection__head__action'
                      onClick={() =>
                        setContentType(
                          contentType.filter((el, idx) => idx !== id)
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      Cancel
                    </p>
                  </label>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      onChange={handleQuizTitle}
                      placeholder='Enter a title for this quiz'
                      onBlur={() => {
                        localStorage.setItem('quizTitle', quizTitle);
                      }}
                    />
                    <div className='eye-icon'></div>
                    <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                      max of 80 characters
                    </p>
                  </div>
                  <div className='add-course__text-editor__cancel'>
                    <div className='activity-check'>
                      <input
                        type='checkbox'
                        onChange={handleCheck}
                        name='quiz'
                        checked={quizActivity}
                      />
                      <p>Check the box if this is an activity for students</p>
                    </div>
                  </div>
                  <Quiz
                    setContentType={setContentType}
                    contentType={contentType}
                    id={id}
                    quizActivity={quizActivity}
                    quizTitle={quizTitle}
                    sn={sn}
                  />
                </div>
              )}

              {contentType[id] === 'Docs' && (
                <div className='add-course__content-wrap'>
                  <label
                    className='add-course__content-selection__head'
                    style={{ marginBottom: '16px' }}
                  >
                    <div
                      className='add-course__content-selection__head__title'
                      style={{ display: 'flex', gap: '16px' }}
                    >
                      {' '}
                      <p>
                        Document {sn + 1}.0.{id + 1}: Create Document Title
                      </p>
                      {docActivity && activityTag()}
                    </div>

                    <p
                      className='add-course__content-selection__head__action'
                      onClick={() =>
                        setContentType(
                          contentType.filter((el, idx) => idx !== id)
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      Cancel
                    </p>
                  </label>
                  <div className='notif'>
                    <Notif />
                    <p>Please ensure this is a pdf file</p>
                  </div>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      onChange={handleDocTitle}
                      placeholder='Enter a title for this document'
                      onBlur={() => {
                        localStorage.setItem('docTitle', docTitle);
                      }}
                    />
                    <div className='eye-icon'></div>
                    <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                      max of 80 characters
                    </p>
                  </div>

                  <div className='dropzone-video'>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <label htmlFor='progress-bar'>{progress}%</label>
                        <progress
                          id='progress-bar'
                          value={progress}
                          max='100'
                        ></progress>
                      </div>
                    ) : docUrl.filter((el) => el.id === id).length > 0 ? (
                      <>
                        <div className='video-preview'>
                          <div className='video-preview__audio'>
                            <BigDoc />
                          </div>
                          <div className='video-preview__video-details'>
                            <div className='video-preview__video-details__icon'>
                              <Docs />
                            </div>
                            <p>
                              {docUrl.filter((el) => el.id === id)[0]?.name}
                            </p>
                          </div>
                        </div>
                        <div
                          className='replace-vid'
                          onClick={() =>
                            setDocUrl(docUrl.filter((el) => el.id !== id))
                          }
                        >
                          <Upload />
                          <p>Replace Document</p>
                        </div>
                      </>
                    ) : (
                      <div className='container'>
                        <div
                          {...getDocRootProps({
                            style,
                            onDrop: (event) => () =>
                              localStorage.setItem('itemId', id),
                            onClick: () => localStorage.setItem('itemId', id),
                          })}
                        >
                          <input {...getDocInputProps()} />
                          <Upload />
                          <p>Drag and drop document or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='add-course__text-editor__cancel'>
                    <div className='activity-check'>
                      <input
                        type='checkbox'
                        onChange={handleCheck}
                        name='doc'
                      />
                      <p>Check the box if this is an activity for students</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}

        {contentSelection && (
          <div
            className='add-course__content-selection'
            style={{ marginBottom: '32px' }}
          >
            <label className='add-course__content-selection__head'>
              <p className='add-course__content-selection__head__title'>
                {' '}
                What type of content do you want to add?
              </p>
            </label>

            <div className='add-course__content-selection__row'>
              {contentTypes.map((el) => (
                <div
                  className='add-course__content-selection__row__selection-item'
                  onClick={() => {
                    // setContentType([...contentType, el.content]);
                    // setPickContentType(false);

                    addMoreContent(el.content);
                    setContentSelection(false);
                  }}
                  key={el.id}
                >
                  <div className='add-course__content-selection__row__selection-item__icon-bg'>
                    {el.icon}
                  </div>

                  <p style={{ color: '#161410' }}>{el.content}</p>
                </div>
              ))}
            </div>
          </div>
        )}
        <div
          className='add-more'
          style={{ marginTop: '24px' }}
          onClick={() => {
            setContentSelection(true);
          }}
        >
          {' '}
          <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z' fill='#FEA82F' />
          </svg>
          <p>Add More Content</p>
        </div>
      </div>
    </div>
  );
};

export default ContentUpload;
